import { PaymentsFilterFormValue } from "./services/payments-filter-form-builder.service";
import { PaymentRefundParams, PaymentsColumnName } from "@helper/types/payment";

export class Get {
	public static readonly type = "[Payments] Get";
	constructor(public filter: PaymentsFilterFormValue) {}
}

export class Select {
	public static readonly type = "[Payments] Select";
	constructor(public paymentIds: number[]) {}
}

export class SetColumns {
	public static readonly type = "[Payments] Set Columns";
	constructor(public columns: PaymentsColumnName[]) {}
}

export class SetPaymentId {
	public static readonly type = "[Payments] Set Payment ID";
	constructor(public paymentId: number) {}
}

export class ClearPaymentId {
	public static readonly type = "[Payments] Clear Payment ID";
}

export class Reset {
	public static readonly type = "[Payments] Reset";
}

export class SetVisible {
	public static readonly type = "[Payments] Set Visible";
	constructor(public paymentsIds: number[]) {}
}

export class SetFilter {
	public static readonly type = "[Payments] Set Filter";
	constructor(public filter: PaymentsFilterFormValue) {}
}

export class RefundPayment {
	public static readonly type = "[Payments] Refund Payment";
	constructor(public payment: PaymentRefundParams) {}
}

export class UpdatePayments {
	public static readonly type = "[Payments] Update Payments";
}

export class UpdatePaymentStatus {
	public static readonly type = "[Payments] Update Payment Status";
	constructor(public paymentId: number, public status: number | null) {}
}
